/* eslint-disable no-useless-escape */
import { getPaths, getTenantId, getTenantDir } from "../plugins/env"
// 默认加上 www 为前缀
// const canonicalizeUrl = url => {
//   if (url.includes("wellcome.com.hk") && !url.includes("://www.")) {
//     return url.replace("://", "://www.")
//   }
//   return url
// }
const canonicalizeUrl = (url, allowedParams = []) => {
  // 1. 确保 URL 使用 www 子域名
  if (url.includes("wellcome.com.hk") && !url.includes("://www.")) {
    url = url.replace("://", "://www.")
  }

  // 2. 解析 URL 并过滤查询参数
  try {
    const urlObj = new URL(url)
    // 如果白名单为空，直接移除所有查询参数和哈希
    if (allowedParams.length === 0) {
      urlObj.search = "" // 清空查询参数
      urlObj.hash = "" // 清空哈希
      return urlObj.toString()
    }

    // 否则，仅保留白名单参数
    const params = new URLSearchParams(urlObj.search)
    const filteredParams = new URLSearchParams()
    for (const [key, value] of params) {
      if (allowedParams.includes(key)) {
        filteredParams.append(key, value)
      }
    }

    // 重新构造 URL（移除哈希，替换查询参数）
    urlObj.search = filteredParams.toString()
    urlObj.hash = ""

    return urlObj.toString()
  } catch (error) {
    console.error("URL 解析失败:", error)
    return url // 解析失败时返回原始 URL
  }
}
// 兜底逻辑，解决x-forwarded-host 获取不到正常domain问题， 根据 tenantId 和环境获取正确的域名
const getProductionOrigin = () => {
  const tenantId = getTenantId()
  const nodeEnv = process.env.NODE_ENV

  // 本地开发环境判断
  const isLocalDev = nodeEnv === "development" || nodeEnv === "production-proxy"

  // 本地开发环境：使用当前域名
  if (isLocalDev) {
    if (process.server) {
      // 服务端：使用请求的域名
      const { MAIN_ORIGIN } = getPaths()
      return MAIN_ORIGIN
    } else {
      // 客户端：使用当前页面域名
      return window.location.origin
    }
  }

  // 根据环境确定域名前缀
  let domainPrefix = ""
  if (nodeEnv === "uat") {
    domainPrefix = "https://uatweb711-hk.rta-os.com"
  } else if (nodeEnv === "test") {
    domainPrefix = "https://testweb711-hk.rta-os.com"
  } else {
    return "https://www.7-eleven.com.hk"
  }

  // UAT 和 test 环境都使用相同的域名，不需要根据 tenantId 区分
  return domainPrefix
}

// 获取 <meta> 标签（支持白名单过滤）
export const getHeadMeta = (item, allowedParams = []) => {
  const fullPath = item.fullPath || ""
  const productionOrigin = getProductionOrigin()
  const url = canonicalizeUrl(productionOrigin + fullPath, allowedParams)
  return [{ name: "og:url", content: url }]
}
export const getHeadLink = item => {
  const { VUE_APP_PUBLIC_PATH } = process.env
  const fullPath = item.fullPath || ""
  // const { MAIN_ORIGIN } = getPaths()
  // const url = canonicalizeUrl(MAIN_ORIGIN + fullPath)
  const productionOrigin = getProductionOrigin()
  const url = canonicalizeUrl(productionOrigin + fullPath)
  return [
    {
      rel: "icon",
      href: `${VUE_APP_PUBLIC_PATH}/public/${getTenantDir()}/favicon.ico`
    },
    {
      rel: "canonical",
      href: url
    },
    {
      rel: "alternate",
      hreflang: item.lang,
      href: url
    }
  ]
}
// 获取 <link> 标签（支持白名单过滤）
// export const getHeadLink = (item, allowedParams = []) => {
//   const { VUE_APP_PUBLIC_PATH } = process.env
//   const fullPath = item.fullPath || ""
//   const productionOrigin = getProductionOrigin()
//   const url = canonicalizeUrl(productionOrigin + fullPath, allowedParams)

//   return [
//     {
//       rel: "icon",
//       href: `${VUE_APP_PUBLIC_PATH}/public/${getTenantDir()}/favicon.ico`
//     },
//     {
//       rel: "canonical",
//       href: url
//     },
//     {
//       rel: "alternate",
//       hreflang: item.lang,
//       href: url
//     }
//   ]
// }
export const insertScript = publicUrl => {
  const script = [
    {
      hid: "chineseAN",
      body: true,
      innerHTML: `
        function getParameterByName(a){
          var hashParams = location.hash? location.hash.split('?')[1]: '';
          var params = location.search? location.search:'?'+hashParams;
          return(a=params.match(new RegExp("[?\x26]"+a+"\x3D([^\x26]*)(\x26?)","i")))?a[1]:a
        }
        var txid = getParameterByName('txId');
        if (txid&&!/[^a-z0-9]/.test(txid)) {
          txid = txid.length>13?txid.substring(0, 13):txid;
          var date = new Date();
          date.setTime(date.getTime()+ 2592000 * 100000);
          var expirationTime = date.toUTCString();
          document.cookie = "txid=" + txid + "; expires=" + expirationTime + "; path=/; domain=." + location.hostname.replace(/^www\./i, "");
        }
      `
    }
  ]
  const noScript = []
  return {
    script,
    noScript
  }
}

const FACEBOOK_PIXEL_ID = {
  0: "182701316148340",
  15: "303964103556776"
}
export const generatorScriptByTenantId = () => {
  const { VUE_APP_PUBLIC_PATH } = process.env
  const tenantId = getTenantId()
  const publicUrl = VUE_APP_PUBLIC_PATH
  const script = [
    {
      hid: "facebook",
      body: true,
      innerHTML: `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${FACEBOOK_PIXEL_ID[tenantId]}');
        fbq('track', 'PageView');
      `
    }
  ]
  const noScript = [
    {
      hid: "noScript",
      body: true,
      innerHTML: `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${FACEBOOK_PIXEL_ID[tenantId]}&ev=PageView&noscript=1"
        />
      `
    }
  ]
  return {
    script,
    noScript
  }
}

export const getStyle = function () {
  const tenantId = getTenantId()
  // tenantId 711 HK is 18 , SG is 19
  console.log("==== getStyle tenantId ===", tenantId)
  const style = `{ 
      --brand-50: #F7F8EF;
      --brand-100: #E6F7ED;
      --brand-200: #9DDFB7;
      --brand-300: #53C782;
      --brand-400: #09AF4C;
      --brand-500: #007350;
      --brand-700: #004530;
      --primary-50: #F7F8EF;
      --primary-100: #E6F7ED;
      --primary-200: #9DDFB7;
      --primary-300: #53C782;
      --primary-400: #09AF4C;
      --primary-500: #007350;
      --primary-700: #004530;
      --secondary-50: #FFF9F5;
      --secondary-100: #FFF4E9;
      --secondary-200: #FDD4A8;
      --secondary-400: #FB9326;
      --secondary-500: #FF6C00;
      --secondary-700: #B34C00;
      --yellow-50: #FFFCF4;
      --yellow-100: #FFF5CC;
      --yellow-200: #FFEC99;
      --yellow-500: #FFCF00;
      --yellow-700: #B39100;
      --delivery-background: var(--yellow-500);
      --progress-define-back: #E5E5E5;
      --progress-success: #46A147;
      --message-box-color: #515151;
      --cart-background:var(--yellow-500);
      --cart-color: #fff;
      --odrer-byAgainColor-color:#000;
      --add-to-cart-color: #ffffff;
      --add-to-cart-background: var(--brand-400);
    }`
  return [
    {
      cssText: `:root ${style};`,
      type: "text/css"
    }
  ]
}
// 获取:root color
export const getRootStyle = function () {
  const root = document.querySelector(":root")
  const primaryColor = getComputedStyle(root).getPropertyValue("--primary-500")
  const brand500 = getComputedStyle(root).getPropertyValue("--brand-500")
  const progressSuccessColor = getComputedStyle(root).getPropertyValue("--progress-success")
  const primary100 = getComputedStyle(root).getPropertyValue("--primary-100")
  const odrerByAgainColor = getComputedStyle(root).getPropertyValue("--odrer-byAgainColor-color")
  return {
    primaryColor,
    brand500,
    progressSuccessColor,
    primary100,
    odrerByAgainColor
  }
}

export const getCommonHead = () => {
  return {
    style: getStyle(),
    script: generatorScriptByTenantId().script,
    noscript: generatorScriptByTenantId().noScript,
    __dangerouslyDisableSanitizers: ["script", "noscript"]
  }
}
